import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { getKioskWorkerReport } from "../../../services/kioskDashboard.service";
import { formatKioskDfaStatus, formatKioskMetric } from "../hooks/kioskDashboard.helpers";

const KioskReportDialog = ({ sessionId, onClose }) => {
  const [state, setState] = useState({ report: null, loading: false, error: null });

  useEffect(() => {
    let active = true;
    if (!sessionId) {
      setState({ report: null, loading: false, error: null });
      return () => { active = false; };
    }

    setState({ report: null, loading: true, error: null });
    getKioskWorkerReport(sessionId)
      .then(report => {
        if (active) setState({ report, loading: false, error: null });
      })
      .catch(error => {
        if (active) setState({ report: null, loading: false, error });
      });

    return () => { active = false; };
  }, [sessionId]);

  const report = state.report || {};
  const metrics = report.medicionActual && report.medicionActual.metricasClinicas;
  const identity = report.identidad || {};

  return (
    <Modal isOpen={Boolean(sessionId)} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Reporte de medición</ModalHeader>
      <ModalBody>
        {state.loading && (
          <div className="flex items-center justify-center gap-2 py-8 text-sm text-slate-500">
            <Spinner size="sm" color="primary" /> Cargando reporte…
          </div>
        )}
        {state.error && (
          <div className="rounded-xl border border-rose-100 bg-rose-50 p-4 text-sm text-rose-700" role="alert">
            No se pudo cargar el reporte de esta medición.
          </div>
        )}
        {!state.loading && !state.error && state.report && (
          <div className="space-y-4">
            <div>
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400">Colaborador</p>
              <p className="mt-1 text-lg font-bold text-[#1D1F3F]">{identity.nombre || "N/D"}</p>
              <p className="text-xs text-slate-500">Sesión #{sessionId}</p>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {[
                ["HRV (RMSSD)", metrics && metrics.rmssd],
                ["SDNN", metrics && metrics.sdnn],
                ["pNN50", metrics && metrics.pnn50],
                ["Puntaje cardiovascular", metrics && metrics.cardiovascularScore],
                ["DFA Alpha-1", metrics && metrics.alpha1],
              ].map(([label, value]) => (
                <div key={label} className="rounded-xl bg-slate-50 border border-slate-100 p-3">
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">{label}</p>
                  <p className="mt-1 text-lg font-bold text-[#1D1F3F]">{formatKioskMetric(value)}</p>
                </div>
              ))}
              <div className="rounded-xl bg-slate-50 border border-slate-100 p-3">
                <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Estado DFA</p>
                <p className="mt-1 text-lg font-bold text-[#1D1F3F]">
                  {formatKioskDfaStatus(metrics && metrics.fatigueStatus)}
                </p>
              </div>
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default KioskReportDialog;
